import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonText, IonLabel, IonFooter, IonLoading } from '@ionic/react';

//import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

//import '../css/hotelCss.css';
//import '../../../../css/qavaApp.css';
import '../../../css/layout.css';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import { format, compareAsc, differenceInDays } from 'date-fns';

import {v4 as uuid} from 'uuid';


export function OrderDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [merchantPhoneNumber, setMerchantPhoneNumber ] = useState(authenticatedMerchent_context.companyPhoneNumber);
    const [merchantPhoneNumber_mtnMomo, setMerchantPhoneNumber_mtnMomo ] = useState(authenticatedMerchent_context.mtnCompanyPhoneNumber);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [orderID, setOrderID] = useState(null);
    let [orderPhoneNumber, setOrderPhoneNumber] = useState(null);
    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);
    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);
    let [clientMemberNumber, setClientMemberNumber] = useState(null);
    let [orderDescription, setOrderDescription] = useState([]);

    let [orderTotal, setOrderTotal] = useState(null);


    let [viewOrderDetailsList, setViewOrderDetailsList] = useState([]);
    let [viewTransactions, setViewTransactions] = useState([]);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);

    let [displaySetButton_pay, setDisplaySetButton_pay] = useState('inline-block');
    let [displayResetButton_pay, setDisplayResetButton_pay] = useState('none');
    let [disableSetButton_pay, setDisableSetButton_pay] = useState(false);
    let [disableResetButton_pay, setDisableResetButton_pay] = useState(false);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [isloading, setLoading] = useState(false);


    let enterPayRef = useRef(0);
    let paymentTypeRef = useRef('MTN-MOMO');


    const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };


    function getOrderDetails() {

        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                Tracker: '74101_view_orders_details',
                user: acctID,
                xOrderID: props.data.orderID,
                sessionID: sessionID,
            }),
        };

        fetch(baseURL + 'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
                let rows = res.toString().split('~~~');
                let cols;

                for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                    cols = rows[rownum].split('|');


                    setViewOrderDetailsList((prevAvailableProducts) => {
                        return prevAvailableProducts.concat({
                            order_id: cols[0],
                            cart_id: cols[1],
                            order_phone_number: cols[2],
                            client_first_name: cols[3],
                            client_last_name: cols[4],
                            client_phone_number: cols[5],
                            client_email_address: cols[6],
                            client_payment_type: cols[7],
                            client_member_number: cols[8],
                            client_mm_provider: cols[9],
                            client_mm_number: cols[10],
                            order_total: parseFloat(cols[11]).toFixed(2),
                            order_amt_paid: parseFloat(cols[12]).toFixed(2),
                            order_start_date_reserved: cols[13],
                            order_end_date_reserved: cols[14],
                            order_start_date: cols[15],
                            order_end_date: cols[16],
                            merchant_invoice_id: cols[17],
                            invoiceForm: cols[18],
                            invoiceForm_customer: cols[19],
                            customer_invoice_id: cols[20],
                            invoiceTotal: parseFloat(cols[21]).toFixed(2),
                            amountOutstanding: parseFloat(cols[22]).toFixed(2),
                            transactionID: cols[23],
                            totalInvoiceAmount: cols[24],
                            transactionStatus: cols[25],
                            momo_provider: cols[26],
                            momo_financial_transaction_id: cols[27],
                            momo_external_id: cols[28],
                            momo_amount: cols[29],
                            momo_party_id: cols[30],
                            momo_payer_message: cols[31],
                            momo_payee_note: cols[32],
                            momo_pay_status: cols[33],
                            payment_type: cols[34],
                            verify_id_type: cols[35],
                            verify_id_number: cols[36],
                            ship_to_address: cols[37],
                            latitude: cols[38],
                            longitude: cols[39],
                            status: cols[40],
                            order_description: cols[41],
                        });
                    });

                    setOrderID(cols[0]);
                    setOrderPhoneNumber(cols[2]);
                    setMerchantInvoiceID(cols[17]);
                    setCustomerInvoiceID(cols[20]);
                    setClientMemberNumber(cols[8]);
                    setOrderDescription(parseArray(cols[41]));



                }

                let rows2 = cols[21].toString().split('_');


                for (let rownum = 0; rownum < rows2.length - 1; ++rownum) {
                    let cols2 = rows2[rownum].split('#');


                    setViewTransactions((prevViewTransactions) => {
                        return prevViewTransactions.concat({
                            transactionID: cols2[0],
                            amount: cols2[1],
                            momo_pay_status: cols2[2],
                            transactionStatus: cols2[3],
                            payment_type: cols2[4],

                        });
                    });
                }
            });
    
    }

    function approvePay(event)
    {

        setLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                Tracker: '33_cash_approved',
                user: acctID,
                xOrderID: event[0],
                xOrderPhoneNumber: event[1],
                xMerchantInvoiceID: event[2],
                xCustomerInvoiceID: event[3],
                xTransactionID: event[4],
                xCustomerAccountID: event[5],
                sessionID: sessionID,
            }),
        };

        fetch(baseURL + 'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
                
                alert(res);
                setLoading(false);
                window.location.href = '/';
            });
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function setPayHandler()
    {
        setDisableSetButton_pay(true);
        setDisplaySetButton_pay('none');
        setDisableResetButton_pay(false);
        setDisplayResetButton_pay('inline-block');

    }

    function resetPayHandler()
    {
        setDisableResetButton_pay(true);
        setDisplayResetButton_pay('none');
        enterPayRef.current.value = '';
        setDisableSetButton_pay(false);
        setDisplayResetButton_pay('none');
        setDisplaySetButton_pay('inline-block');
    }

    function closeModalHandler() {

        setViewOrderDetailsList([]);
        props.closeModal(false);
    }



    useEffect(() =>
    {
        getOrderDetails();

    }, [])

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
            <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h3>ORDER DETAILS</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> Order ID</IonCol>
                        <IonCol size='6'> Order Total</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> {props.data.orderID} </IonCol>
                        <IonCol size='6'> {props.data.orderTotal} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

            {viewOrderDetailsList.map((detailData) =>   {
            return (
            <IonGrid>
                <IonRow >
                    <IonCol size='3' ><h3>Category</h3></IonCol>
                    <IonCol size='6' ><h3>Value</h3></IonCol>
                    <IonCol size='3' ><h3>Action</h3></IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ><IonLabel>Merchant Invoice</IonLabel></IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{detailData.merchant_invoice_id}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.order_total, detailData.invoiceForm])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ><IonLabel>Customer Invoice</IonLabel></IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{detailData.merchant_invoice_id}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.order_total, detailData.invoiceForm_customer])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Contact</IonCol>
                    <IonCol size='6' style={{fontSize: 'small'}}>{ 'Name: '+detailData.client_first_name+' '+detailData.client_last_name+
                                                        ', Phone #: '+detailData.client_phone_number+
                                                        ', Email: '+detailData.client_email_address}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow className="outlinedRow">
                    <IonCol >DESCRIPTION</IonCol>
                </IonRow>
                <IonRow className="outlinedRow outlinedHeader">
                    <IonCol size='2'>ID</IonCol>
                    <IonCol size='4'>NAME</IonCol>
                    <IonCol size='3'>PRICE</IonCol>
                    <IonCol size='3'>QTY</IonCol>
                </IonRow>
                {orderDescription.map((it) => {
                    return (
                        <IonRow className="outlinedRow">
                            <IonCol size='2'>
                                {it.id}
                            </IonCol>
                            <IonCol size='4'>
                                {it.name}
                            </IonCol>
                            <IonCol size='3'>
                                {it.price}                              
                            </IonCol>
                            <IonCol size='3'>
                                {it.quantity}                              
                            </IonCol>
                        </IonRow>
                    )}
                )}
                <IonRow >
                    <IonCol size='3' >Payment Type</IonCol>
                    <IonCol size='6' >{detailData.payment_type}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Amount Paid</IonCol>
                    <IonCol size='6' >{parseFloat(detailData.invoiceTotal - detailData.amountOutstanding).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Balance</IonCol>
                    <IonCol size='6' >{detailData.amountOutstanding}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                {/*<IonRow >
                    <IonCol size='12'>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                    <IonCol size='3' >Pay</IonCol>
                    <IonCol size='6'>
                        <IonInput style={{display: displaySetButton_pay}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton_pay}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_pay}} disabled={disableSetButton_pay} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_pay}} disabled={disableResetButton_pay} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                </IonRow >*/}
            </IonGrid>
                    )
                }
            )}


            {viewTransactions.map((detailData2) =>   {
            return (
                <IonGrid>
                    {detailData2.payment_type == 'CASH' && 
                    <IonRow >
                        <IonCol size='3'>
                            <IonText>Amount</IonText>
                        </IonCol>
                        <IonCol size='3'>
                            <IonText>{detailData2.amount}</IonText>
                        </IonCol>
                        <IonCol size='3' >
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.transactionStatus == 'PC') && detailData2.payment_type == 'CASH') &&   <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => approvePay([orderID, orderPhoneNumber, merchantInvoiceID, customerInvoiceID, detailData2.transactionID, clientMemberNumber])}> APPROVE</IonButton>}
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.transactionStatus == 'C') && detailData2.payment_type == 'CASH') &&   <IonButton id='gridResultColumnButton'  disabled={true}> - </IonButton>}
                        </IonCol>
                    </IonRow>
                    }
                    {(detailData2.payment_type == 'mm' || detailData2.payment_type == 'MTN-MOMO') && 
                    <IonRow >
                        <IonCol size='3'>
                            <IonText>Amount</IonText>
                        </IonCol>
                        <IonCol size='3'>
                            <IonText>{detailData2.amount}</IonText>
                        </IonCol>
                        <IonCol size='3' >
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.transactionStatus == 'PC') && detailData2.payment_type == 'CASH') &&   <IonButton id='gridResultColumnButton'  disabled={disablePayButton}> PENDING</IonButton>}
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.transactionStatus == 'C') && detailData2.payment_type == 'CASH') &&   <IonButton id='gridResultColumnButton'  disabled={true}> - </IonButton>}
                        </IonCol>
                    </IonRow>
                    }
                </IonGrid>
                    )}
            )}
    
            {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                }}></ViewInvoiceModal>}

            {isloading == true && <IonLoading
                                    isOpen={isloading}
                                    message={'Please wait...'}
                                    duration={0} // Show until manually dismissed
                                />}
        </IonContent>
        <IonFooter className='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
    </IonModal>) : null}
    </React.Fragment>
    )
}